import isArray from "lodash/isArray";

import isPrimitive from "./isPrimitive";

export default function getObjectPrimitiveValues(objectOrArray = {}) {
  const arr = isArray(objectOrArray)
    ? objectOrArray
    : Object.values(objectOrArray);

  return arr.flatMap((a) => {
    return isPrimitive(a) ? a : getObjectPrimitiveValues(a);
  });
}
